import nayeon from '../../assets/membersimgs/nayeon.jpg';
import jeongyeon from '../../assets/membersimgs/jeongyeon.jpg'
import momo from '../../assets/membersimgs/momo.jpg'
import sana from '../../assets/membersimgs/sana.jpg'
import jihyo from '../../assets/membersimgs/jihyo.jpg'
import mina from '../../assets/membersimgs/mina.jpg'
import dahyun from '../../assets/membersimgs/dahyun.jpg'
import chaeyoung from '../../assets/membersimgs/chaeyoung.jpg'
import tzuyu from '../../assets/membersimgs/tzuyu.jpg'

import nayeonchibi from '../../assets/membersimgs/nayeonchibi.jpg'
import jeongyeonchibi from '../../assets/membersimgs/jeongyeonchibi.jpg'
import momochibi from '../../assets/membersimgs/momochibi.jpg'
import sanachibi from '../../assets/membersimgs/sanachibi.jpg'
import jihyochibi from '../../assets/membersimgs/jihyochibi.jpg'
import minachibi from '../../assets/membersimgs/minachibi.jpg'
import dahyunchibi from '../../assets/membersimgs/dahyunchibi.webp'
import chaeyoungchibi from '../../assets/membersimgs/chaeyoungchibi.jpg'
import tzuyuchibi from '../../assets/membersimgs/tzuyuchibi.jpg'

export const TWICE_MEMBERS = [
  {
    id: 1,
    name: "Im Na-yeon",
    stagename: "Nayeon",
    age: 30,
    birthDate: "September 22, 1995",
    nationality: "South Korean",
    role: "Lead Vocalist, Center",
    color: "#81D4FA", 
    emoji: "🐰",
    image: nayeon,
    chibiimage: nayeonchibi
  },
  {
    id: 2,
    name: "Yoo Jeong-yeon",
    stagename: "Jeongyeon",
    age: 29,
    birthDate: "November 1, 1996",
    nationality: "South Korean",
    role: "Lead Vocalist",
    color: "#AED581", // Yellow-Green
    emoji: "🐶",
    image: jeongyeon,
    chibiimage: jeongyeonchibi
  },
  {
    id: 3,
    name: "Hirai Momo",
    stagename: "Momo",
    age: 29,
    birthDate: "November 9, 1996",
    nationality: "Japanese",
    role: "Main Dancer, Sub Vocalist",
    color: "#F48FB1", // Pink
    emoji: "🍑",
    image: momo,
    chibiimage: momochibi
  },
  {
    id: 4,
    name: "Minatozaki Sana",
    stagename: "Sana",
    age: 29,
    birthDate: "December 29, 1996",
    nationality: "Japanese",
    role: "Sub Vocalist",
    color: "#CE93D8", // Purple
    emoji: "🐹",
    image: sana,
    chibiimage: sanachibi
  },
  {
    id: 5,
    name: "Park Ji-hyo",
    stagename: "Jihyo",
    age: 29,
    birthDate: "February 1, 1997",
    nationality: "South Korean",
    role: "Leader, Main Vocalist",
    color: "#FFCC80", // Apricot
    emoji: "🦄",
    image: jihyo,
    chibiimage: jihyochibi
  },
  {
    id: 6,
    name: "Myoui Mina",
    stagename: "Mina", 
    age: 28,
    birthDate: "March 24, 1997", // Fixed typo "birtDate"
    nationality: "Japanese/American",
    role: "Main Dancer, Sub Vocalist",
    color: "#80CBC4", // Mint
    emoji: "🐧",
    image: mina,
    chibiimage: minachibi
  },
  {
    id: 7,
    name: "Kim Da-hyun",
    stagename: "Dahyun",
    age: 27,
    birthDate: "May 28, 1998",
    nationality: "South Korean",
    role: "Lead Rapper, Sub Vocalist",
    color: "#FFFFFF", // White
    emoji: "🦅",
    image: dahyun,
    chibiimage: dahyunchibi
  },
  {
    id: 8,
    name: "Son Chae-young",
    stagename: "Chaeyoung",
    age: 26,
    birthDate: "April 23, 1999",
    nationality: "South Korean",
    role: "Main Rapper, Sub Vocalist",
    color: "#EF5350", // Red
    emoji: "🐯",
    image: chaeyoung,
    chibiimage: chaeyoungchibi
  },
  {
    id: 9,
    name: "Chou Tzu-yu",
    stagename: "Tzuyu",
    age: 26,
    birthDate: "June 14, 1999",
    nationality: "Taiwanese",
    role: "Lead Dancer, Visual, Maknae",
    color: "#42A5F5", // Blue
    emoji: "🦌",
    image: tzuyu,
    chibiimage: tzuyuchibi
  }
];